import React from 'react';
import { PageNotFound as CompPageNotFound } from 'components/bot';

export const PageNotFound = () => <CompPageNotFound />;
